import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import { vendorAdd, vendorList } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";

const Vendor = () => {
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [vendor, setVendor] = useState([]);
  const [currentuser, setCurrentUser]=useState(null)
  

              const [currentPage, setCurrentPage] = useState(1);
              const itemsPerPage = 10;
              
              const indexOfLast = currentPage * itemsPerPage;
              const indexOfFirst = indexOfLast - itemsPerPage;
              
              const currentUsers = vendor.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    const fetchVendorList = async () => {
      try {
        const response = await vendorList(token);
        console.log("Vendor : ", response);
        setVendor(response);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };

    fetchVendorList();
  }, []);

  const toggleStatus = async (id) => {
    // try {
    //   const response = await updateSubCategoryToggle(id);
    //   console.log("toggle status :", response);
    //   if (response.data.status === "success") {
    //     setSubcategoryUpdated((prev) => !prev);
    //   }
    // } catch (error) {
    //   console.error("Error updating profile:", error);
    // }
  };

  return (
    <div id="main_content">
      <Header />
      <div className="page">
       
<Section/>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Vendor</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Vendor
                  </li>
                </ol>
              </div>
             
            </div>
          </div>
        </div>

        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Vendor-all">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover js-basic-example dataTable table-striped table_custom border-style spacing5">
                        <thead>
                          <tr>
                            <th style={{textAlign:"center"}}>Id</th>
                            <th style={{textAlign:"center"}}>First Name</th>
                            <th style={{textAlign:"center"}}>Vendor Company Name</th>
                            <th style={{textAlign:"center"}}>Vendor Gst Number</th>
                            <th style={{textAlign:"center"}}>Status</th>
                            <th style={{textAlign:"center"}}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentUsers?.map((vendor,ind) => (
                            <tr key={vendor?.id}>
                              <td>{indexOfFirst+ind+1}</td>
                              <td>{vendor?.firstName}</td>
                              <td>{vendor?.vendorCompanyName}</td>
                              <td>{vendor?.vendorGstNumber}</td>
                              <td>
                                <button
                                  className={`btn btn-sm ${
                                    vendor?.status
                                      ? "btn-primary"
                                      : "btn-danger"
                                  }`}
                                  onClick={() => toggleStatus(vendor?.id)}
                                >
                                  {vendor?.status ? "Active" : "Inactive"}
                                </button>
                              </td>
                              <td>
                                <button onClick={()=>setCurrentUser(vendor)}
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="View"
                                >
                                  <i className="fa fa-eye" />
                                </button>
                               
                                
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                                              <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(vendor.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(vendor.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
                            </div>
                    </div>
                  </div>
                </div>
              </div>
                {
          currentuser && (<div style={{position:"absolute",top:"100px",right:"200px",zIndex:999,backgroundColor:"white",padding:"14px",border:"0.5px solid gray",borderRadius:"10px",minWidth:"450px"}}>
          <div  role="dialog">
            <p onClick={()=>setCurrentUser(null)} 
            style={{position:"absolute",right:"10px",cursor:"pointer",fontSize:"13px",padding:"5px",height:"30px",width:"30px",backgroundColor:"#cacacaff",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center"}}>X</p>
            <div  role="document">
              <p style={{fontSize:"20px",fontWeight:"800"}}>Vendor Name:{currentuser.firstName}</p>
              <p style={{fontWeight:"600",color:"#999999ff"}}>Vendor GST Number:{currentuser.vendorGstNumber}</p>
              <p style={{fontWeight:"600",color:"#999999ff"}}>Warehouse Name:{currentuser.warehouseName}</p>
              <p style={{fontSize:"14px"}}>Latitude-{currentuser.latitude||0},Longitude-{currentuser.longitude||0}</p>
              <p style={{fontSize:"14px"}}>Vendor Company:{currentuser.vendorCompanyName}</p>
              
              </div>
            </div>
          </div>)
        }
              <div className="tab-pane" id="Vendor-add">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Add Vendor</h3>
                    <div className="card-options ">
                      <a
                        href="#"
                        className="card-options-collapse"
                        data-toggle="card-collapse"
                      >
                        <i className="fe fe-chevron-up" />
                      </a>
                      <a
                        href="#"
                        className="card-options-remove"
                        data-toggle="card-remove"
                      >
                        <i className="fe fe-x" />
                      </a>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div className="tab-pane" id="Vendor-add-Boot">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Add Vendor</h3>
                    <div className="card-options ">
                      <a
                        href="#"
                        className="card-options-collapse"
                        data-toggle="card-collapse"
                      >
                        <i className="fe fe-chevron-up" />
                      </a>
                      <a
                        href="#"
                        className="card-options-remove"
                        data-toggle="card-remove"
                      >
                        <i className="fe fe-x" />
                      </a>
                    </div>
                  </div>
                  {/* <form className="card-body" onSubmit={handleSubmit}>
                    <div className="form-group row">
                      <label className="col-md-3 col-form-label">
                        Common User ID <span className="text-danger">*</span>
                      </label>
                      <div className="col-md-7">
                        <input
                          type="text"
                          className="form-control"
                          name="commonUserId"
                          value={formData.commonUserId}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-3 col-form-label">
                        GST Number <span className="text-danger">*</span>
                      </label>
                      <div className="col-md-7">
                        <input
                          type="text"
                          className="form-control"
                          name="vendorGstNumber"
                          value={formData.vendorGstNumber}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-3 col-form-label">
                        Company Name <span className="text-danger">*</span>
                      </label>
                      <div className="col-md-7">
                        <input
                          type="text"
                          className="form-control"
                          name="vendorCompanyName"
                          value={formData.vendorCompanyName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-3 col-form-label">
                        Vendor Image <span className="text-danger">*</span>
                      </label>
                      <div className="col-md-7">
                        <input
                          type="file"
                          className="form-control"
                          name="vendorImage"
                          onChange={handleFileChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-3 col-form-label" />
                      <div className="col-md-7">
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default Vendor;
